module.exports = __webpack_public_path__ + "img/16m008-15.47254020.png";